import React from "react";
import { Container, Divider, makeStyles, Typography } from "@material-ui/core";
import FlipCard from "./FlipCard";
import "./gallery.css";

import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
import "./carousel.css";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  heading: {
    marginTop: "5vh",
    letterSpacing: "1px",
    color: "#383838",
  },
  divider: {
    height: "6px",
    width: "20%",
    margin: "1vh auto",
    background: "linear-gradient(to right, #ffff00 0%, #33cc33 100%)",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
  },
  responsive: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-evenly",
  },
}));

function Gallery(props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      paritialVisibilityGutter: 60,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 50,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 30,
    },
  };
  const classes = useStyles();
  const { projects } = props;
  const content = projects.map((item, ind) => <FlipCard key={ind} {...item} />);
  return (
    <div className={classes.root} id="gallery">
      <Container maxWidth="xl" style={{ margin: "4vh 0" }}>
        <Typography className={classes.heading} variant="h3" align="center">
          PROJECTS
        </Typography>
        <Divider className={classes.divider} variant="fullWidth" />
        <Carousel
          itemClass="image-item"
          responsive={responsive}
          showDots={false}
          autoPlay={true}
          infinite={true}
          autoPlaySpeed={5000}
        >
          {content.map((item, ind) => (
            <div key={ind}>{item}</div>
          ))}
        </Carousel>
      </Container>
    </div>
  );
}

export default Gallery;
